import { useHistory } from 'react-router-dom'
import React, { useCallback, useMemo, useState } from 'react'
import { getAssetBackgroundImage, getAssetTitle } from '../../services/asset'
import { PARTNER_IDENTIFIER } from '../../services/partners'
import { AnimatePresence, motion } from 'framer-motion'
import { fade } from '../../storage/motionAnimations'
import { Skeleton } from '@mui/material'

export const SRSlide = ({ asset }) => {
  const history = useHistory();

  const [imgLoaded, setImgLoaded] = useState(false);

  const backgroundImage = useMemo(
    () => (asset ? getAssetBackgroundImage(asset, "800x450") : ""),
    [asset]
  );

  const onImageLoad = useCallback(() => {
    setImgLoaded(true);
  }, [backgroundImage]);

  const onClick = useCallback(() => {
    history.push(`/asset/${PARTNER_IDENTIFIER.RLAXX}/${asset.id}`);
  }, [asset]);

  return (
    <div className="slide-wrapper" onClick={onClick}>
      <div className="slide-image">
        <img
          className="asset-image"
          src={backgroundImage}
          onLoad={onImageLoad}
          alt="Asset Cover"
        />
        <AnimatePresence>
          {!imgLoaded && (
            <motion.div
              variants={fade}
              initial="visible"
              animate="visible"
              exit="exit"
              className="skelly-wrapper"
            >
              <Skeleton
                className="skelly"
                animation="wave"
                variant="rectangular"
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
      <h1 className="asset-title">{getAssetTitle(asset)}</h1>
    </div>
  );
};
